var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "menu-icon",
    width: "25px",
    height: "17px",
    viewBox: "0 0 25 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-270.000000, -28.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(270.000000, 28.000000)",
    fill: "#22252A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-top",
    points: "8 0 8 3 25 3 25 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-middle",
    points: "8 7 8 10 25 10 25 7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-cross-left",
    className: "cross-part",
    points: "8 7 8 10 25 10 25 7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-cross-right",
    className: "cross-part",
    points: "8 7 8 10 25 10 25 7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-bottom",
    points: "8 14 8 17 25 17 25 14"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.22cadc265b80fa0ed6897114d7dcc249.svg";
export { ForwardRef as ReactComponent };